import { Controller } from "@hotwired/stimulus"

/**
 * Sidebar Controller
 *
 * Handles collapsible sidebar with icon-only and expanded states.
 * Persists collapsed state in localStorage.
 *
 * Usage:
 *   <aside data-controller="sidebar" data-sidebar-collapsed-class="w-16" data-sidebar-expanded-class="w-64">
 *     <button data-action="click->sidebar#toggle">Toggle</button>
 *     <span data-sidebar-target="label">Menu Item</span>
 *   </aside>
 */
export default class extends Controller {
  static targets = ["label", "section", "toggle", "logo", "arrow"]
  static classes = ["collapsed", "expanded"]

  connect() {
    this.collapsed = localStorage.getItem("sidebar-collapsed") === "true"
    this.apply()
  }

  toggle() {
    this.collapsed = !this.collapsed
    localStorage.setItem("sidebar-collapsed", this.collapsed)
    this.apply()
  }

  toggleSection(event) {
    const section = event.currentTarget.closest("[data-sidebar-section]")
    if (!section) return
    const content = section.querySelector("[data-sidebar-target='section']")
    if (!content) return

    const isOpen = content.classList.contains("max-h-96")
    content.classList.toggle("max-h-0", isOpen)
    content.classList.toggle("max-h-96", !isOpen)
    content.classList.toggle("opacity-0", isOpen)
    content.classList.toggle("opacity-100", !isOpen)

    // Rotate arrow
    const arrow = event.currentTarget.querySelector("[data-sidebar-target='arrow']")
    if (arrow) {
      arrow.classList.toggle("rotate-90", !isOpen)
    }
  }

  apply() {
    if (this.collapsed) {
      this.element.classList.remove("w-64")
      this.element.classList.add("w-16")
    } else {
      this.element.classList.remove("w-16")
      this.element.classList.add("w-64")
    }

    this.labelTargets.forEach((el) => {
      el.classList.toggle("hidden", this.collapsed)
      el.classList.toggle("opacity-0", this.collapsed)
    })

    if (this.hasLogoTarget) {
      this.logoTarget.classList.toggle("hidden", this.collapsed)
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.classList.toggle("rotate-180", this.collapsed)
    }
  }
}
